import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Alert } from 'react-bootstrap';
import { Meteor } from 'meteor/meteor';
import { Accounts } from 'meteor/accounts-base';
import { Bert } from 'meteor/themeteorchef:bert';

import { getRedirectPath } from '../../../modules/checkDeployEnv';
import handleErrorInClient from '../../../modules/handle-error-in-client';

class VerifyEmail extends Component {
  state = { error: null };

  componentDidMount() {
    const { match } = this.props;
    Accounts.verifyEmail(match.params.token, error => {
      if (error) {
        handleErrorInClient(error);
        this.setState({ error: `${error.reason}. Please try again.` });
      } else {
        setTimeout(() => {
          const { history, deployEnv } = this.props;
          Bert.alert('All set, thanks!', 'success');
          Meteor.call('users.sendWelcomeEmail', errorMethod => {
            if (errorMethod) {
              Bert.alert(errorMethod.reason, 'danger');
            } else {
              history.push(getRedirectPath(deployEnv));
            }
          });
        }, 1500);
      }
    });
  }

  render() {
    const { error } = this.state;
    return <Alert variant={!error ? 'info' : 'danger'}>{!error ? 'Verifying...' : error}</Alert>;
  }
}

VerifyEmail.propTypes = {
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  deployEnv: PropTypes.string.isRequired
};

export default VerifyEmail;
